export default __webpack_public_path__ + "static/media/A10.e6731296.png";